import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { BatchConfigurationComponent } from 'src/app/shared/components/batch-configuration/batch-configuration.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { SubidaDocumentoComponent } from '../../subida-documento/subida-documento';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { LoteCertificadoComponent } from '../../lote-certificado/lote-certificado';
import { AsociacionFirmaComponent } from '../../asociacion-firma-documento/asociacion-firma-documento.component';
import { LoadingService } from 'src/app/core/services/loading.service';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { LoteService } from 'src/app/core/services/lote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-firma-component',
    templateUrl: './firma-simple.component.html',
    styleUrls: ['./firma-simple.css']
})
export class FirmaSimpleComponent implements OnInit {
    @ViewChild(BatchConfigurationComponent) batchConfigComponent!: BatchConfigurationComponent;
    @ViewChild(SubidaDocumentoComponent) subidaDocumentoComponent!: SubidaDocumentoComponent;
    @ViewChild(LoteCertificadoComponent) loteCertificadoComponent!: LoteCertificadoComponent;
    @ViewChild(AsociacionFirmaComponent) asociacionFirmaComponent!: AsociacionFirmaComponent;
    @ViewChild(StepperComponent) stepperComponent!: StepperComponent;
    stepActual = 0;
    userModule = true;
    lote: any;
    public short_estado_lote: string = '';
    public titulo: string = ''
    public titulo_step: string = ''
    public info_step: string = ''
    public animationArray = ['/assets/lottie/add.json', '/assets/lottie/uploading2.json', '/assets/lottie/signature2.json']

    private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente

    form = {
        nombre: '',
        email: ''
    };

    // Toast
    toast = Swal;
    constructor(
        private firmaService: FirmaStateService,
        private loteService: LoteService,
        private route: ActivatedRoute,
        public loading: LoadingService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private location: Location
    ) {

    }


    ngOnInit() {
        /* NO BORRAR, ESTO HACE QUE LOS ESTADOS GLOBALES 
           HAGAN UN RESET CADA VEZ QUE SE CREA UN NUEVO LOTE */
        this.toastAlert();
        this.firmaService.resetForm();

        this.route.paramMap
            .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
            .subscribe(async params => {
                // 'id' es el nombre del parámetro definido en tu configuración de rutas
                // Por ejemplo: path: 'firmas/firma/:id'
                const id = params.get('id');

                if (id != "firma") {
                    this.lote = await this.showLote(parseInt(id))
                    this.titulo = 'Editar Sobre';
                } else {
                    this.titulo = 'Crear Sobre';
                    
                }
            });
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    async showLote(id: number) {
        const lote = await lastValueFrom(this.loteService.show(id));
        return lote;
    }



    changeStepChildren(stepper: any) {
        this.onStepChange(stepper);
    }

    async onStepChange(nuevoPaso: number) {
        
        if (this.loading.loading()) {
            
            return;
        }

        this.loading.start();
        this.stepActual = nuevoPaso;

        let canAdvance = false;

        // Lógica para guardar y validar los datos del paso actual
        switch (this.stepActual) {
            case 0: // Corresponde al Paso 1: Configuración de Lote
                this.titulo_step = 'Configuración inicial de Carga Masiva.';
                this.info_step = 'Crea un lote o conjunto de documentos que tendrán la misma configuración para solicitar firmar digitalmente.';
                if (this.batchConfigComponent) {
                    canAdvance = await this.batchConfigComponent.saveFormData(); // Llama al método público del componente hijo
                } 
                break;
            case 1: // Paso 2: subida de documentos
                this.titulo_step = 'Carga de documento(s) a configurar.';
                this.info_step = '';
                if (this.subidaDocumentoComponent) {
                    canAdvance = await this.subidaDocumentoComponent.validCantidadDocumentos();
                    if (!canAdvance) {

                        this.alert('warning', 'Debe anexar documentos antes de continuar');
                    }
                }

                break;
            case 2: // Paso 3: asociacion de certificados
                this.titulo_step = 'Asociar Firmantes - certificados digitales con áreas de firma.';
                this.info_step = 'Buscar por correo electrónico y asocia su certificado.';

                if (this.loteCertificadoComponent) {
                    canAdvance = await this.loteCertificadoComponent.validCantidadCertificados();
                }
                break;
            case 3: // Paso 4: asociación de coordenadas
                this.titulo_step = 'Verificar áreas de firma por documento.';
                this.info_step = 'En este paso el proceso debe completar de forma automática las áreas de firma por documento.';
                if (this.asociacionFirmaComponent) {
                    canAdvance = await this.asociacionFirmaComponent.validStatusFirma();
                }
                break;

            case 4:
                this.titulo_step = 'Firma de documento.';
                this.info_step = 'Se puede pre visualizar el documento a firmar.';
                break;
        }

        if (canAdvance) {
            this.stepActual++;
            this.firmaService.setCurrentStep(this.stepActual);
        }

        this.loading.stop();

    }

    validateModuleUser(validate: boolean) {
        this.userModule = validate;
    }

    validateUltimaEtapaF(validate: string) {

        setTimeout(() => {
            this.short_estado_lote = validate;
        }, 0);
    }


    irAlPaso2() {
        this.stepActual = 1;
    }

    guardar() {
        alert('Formulario enviado correctamente');

    }

    rederict() {
        
        this.location.back();
    }

    volverInicio() {
        this.router.navigate(['/']); // o la ruta que quieras
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string) {
        this.toast.fire({
            icon: icontext,
            title: title
        });
    }

}
